// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	if (window.matchMedia("(max-width: 1024px)").matches) {

		const expandLinks = document.querySelectorAll('.expand-submenu');

		expandLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const parentItem = link.closest('li');
				const submenu = parentItem.querySelector('.sub-sub-menu');

				const isOpen = parentItem.classList.contains('active-menu');
				document.querySelectorAll('li.active-menu')
					.forEach(item => {
						item.classList.remove('active-menu');
						const sub = item.querySelector('.sub-sub-menu');
						if (sub) sub.setAttribute('aria-hidden', 'true');
					});

				parentItem.classList.toggle('active-menu', !isOpen);
				submenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
			});

		});

	}

	if(window.innerWidth < 800) {
		document.querySelectorAll('.sub-menu__hold').forEach(menu => {
			const nav = menu.querySelector('.sub-menu');
			const list = nav.querySelector('ul');
			const active = nav.querySelector('a.active') || nav.querySelector('a');

			if (!active) return;

			// crear botón visible
			const trigger = document.createElement('button');
			trigger.className = 'sub-menu__trigger';
			trigger.type = 'button';
			trigger.textContent = active.textContent;

			menu.prepend(trigger);

			// estado inicial
			menu.classList.add('dropdown-ready');

			// toggle dropdown
			trigger.addEventListener('click', () => {
				menu.classList.toggle('open');
			});

			// cerrar al click afuera
			document.addEventListener('click', e => {
				if (!menu.contains(e.target)) {
				menu.classList.remove('open');
				}
			});
		});

	}

	if (window.innerWidth > 900) {
		const itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
    	let customCounter = 0;

		itemsMenu.forEach((itemMenu) => {
			const submenu = itemMenu.querySelector('.submenu:not(.submenu .submenu)');
			if (!submenu) return;

			const boxItem = document.createElement('div');
			boxItem.classList.add('privary-navigation__box');
			boxItem.innerHTML = `
				<div class="privary-navigation__box-image">
					<img src="" alt="" loading="lazy" data-navimg="${customCounter}">
				</div>
				<div class="privary-navigation__box-content"></div>
			`;

			const boxContent = boxItem.querySelector('.privary-navigation__box-content');

			boxContent.appendChild(submenu);
			itemMenu.appendChild(boxItem);

			itemMenu.addEventListener('mouseenter', () => {
				itemMenu.classList.add('hover');
				submenu.classList.add('show');
			});

			itemMenu.addEventListener('mouseleave', () => {
				itemMenu.classList.remove('hover');
				submenu.classList.remove('show');
			});

			customCounter++;
		});

		const navImagesGoFrom = document.querySelectorAll('.header__navimg [data-navgo]');
		const navImagesGoTo = document.querySelectorAll('.privary-navigation__box [data-navimg]');

		const imageMap = {};

		navImagesGoTo.forEach(img => {
			imageMap[img.dataset.navimg] = img;
		});

		navImagesGoFrom.forEach(img => {
			const targetKey = img.dataset.navgo;
			if (imageMap[targetKey]) {
				imageMap[targetKey].src = img.src;
			}
		});
	}
	

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
		if(document.querySelector('.js-menu-burger')){
			document.querySelector('.js-menu-burger').addEventListener('click', () => {
				document.querySelector('.js-menu-container').classList.add('open');
			})
		}
		if(document.querySelector('.js-menu-container_close')){
			document.querySelector('.js-menu-container_close').addEventListener('click', () => {
				document.querySelector('.js-menu-container').classList.remove('open');
			})
		}
		if (window.location.hash) {
			const el = document.querySelector(window.location.hash);
			if (el) {
			el.scrollIntoView({ behavior: "smooth" });
			}
		}
	};

	// Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//const flexGallery = new LBX('.lbx-main-gallery', {});
	const ImagesLightbox = new LBX('.js-img-lbx', {});

	const fullScreen = new LBX('.lbx-fullscreen', {});
	fullScreen.fullScreen = true;

	fullScreen.icons.close = 
		'<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36 30"><defs><style>.st0 {fill: #231f20;}</style></defs><path d="M25.13,22.59c-.12,0-.24-.04-.33-.13l-6.81-6.81-6.81,6.81c-.18.18-.47.18-.65,0s-.18-.47,0-.65l6.81-6.81-6.81-6.81c-.18-.18-.18-.47,0-.65s.47-.18.65,0l6.81,6.81,6.81-6.81c.18-.18.47-.18.65,0s.18.47,0,.65l-6.81,6.81,6.81,6.81c.18.18.18.47,0,.65-.09.09-.21.13-.33.13Z"/><path class="st0" d="M18,28.33c-7.35,0-13.33-5.98-13.33-13.33S10.65,1.67,18,1.67s13.33,5.98,13.33,13.33-5.98,13.33-13.33,13.33ZM18,2.67c-6.8,0-12.33,5.53-12.33,12.33s5.53,12.33,12.33,12.33,12.33-5.53,12.33-12.33S24.8,2.67,18,2.67Z"/></svg>';

	let secondaryNav = document.querySelector('#secondary-navigation');

	if(secondaryNav){
		secondaryNav.querySelectorAll('a').forEach(link => {
			let text = link.innerText;
			if(text.toLowerCase().includes('careers')){
				link.classList.add('custom_click_track');
				link.setAttribute('data-custom_click_track_value', 'Footer: Careers|Activity Link Click|external|event464');
			}
		})
	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
			(document.querySelector('.js-header-logo')) ? document.querySelector('.js-header-logo').src = document.querySelector('.js-header-logo').dataset.scroll : '';
			(document.querySelector('.js-header-logo') && !document.querySelector('.js-header-logo').classList.contains('scroll')) ? document.querySelector('.js-header-logo').classList.add('scroll') : '';
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
			(document.querySelector('.js-header-logo')) ? document.querySelector('.js-header-logo').src = document.querySelector('.js-header-logo').dataset.original : '';
			(document.querySelector('.js-header-logo') && document.querySelector('.js-header-logo').classList.contains('scroll')) ? document.querySelector('.js-header-logo').classList.remove('scroll') : '';
		}
		
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//cms form focus animation
if(document.querySelectorAll('.form-module__field').length > 0){
	document.querySelectorAll('.form-module__field').forEach( field => {
		if(field.querySelector('input')){
			field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
		}
		if(field.querySelector('select')){
			field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
		}
		if(field.querySelector('textarea')){
			field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
		}
	});
}
